import noop from 'lodash/noop';
import React from 'react';
import styled from 'styled-components';

import { Radio } from 'ui/radio';
import { Row } from 'ui/radioList/RadioListStyles';
import { Label, spacing } from 'ui/theme';

interface RadioRowProps {
  isDisabled?: boolean;
  isChecked?: boolean;
  label?: string;
  value: string;
  onSelect: (value: string) => void;
}

const StyledRow = styled(Row)`
  flex: 1 1 100%;
  margin-bottom: ${spacing.half};
`;

const RadioSection = styled.div`
  flex: 0 0 auto;
`;

const ContentSection = styled.div`
  flex: 1 1 auto;
`;

const RadioRow = ({
  isChecked = false,
  isDisabled = false,
  value,
  label,
  onSelect = noop,
  children,
  htmlFor,
}: React.PropsWithChildren<RadioRowProps & { htmlFor?: string }>) => {
  return (
    <StyledRow
      isDisabled={isDisabled}
      isReadOnly={isDisabled}
      isChecked={isChecked}
      isBordered={false}
      onClick={() => !isDisabled && onSelect(value)}
    >
      <RadioSection>
        <Radio
          value={value}
          data-test={`radio-${value}`}
          isDisabled={isDisabled}
          isChecked={isChecked}
        />
      </RadioSection>
      <ContentSection>
        <div>
          <Label htmlFor={htmlFor}>{label}</Label>
        </div>
        <div>{isChecked && children}</div>
      </ContentSection>
    </StyledRow>
  );
};

export default RadioRow;
